import useUserInfo from './useUserInfo';

const useUserAttributes: () => Record<string, any> = () =>
  useUserInfo()?.attributes ?? {};

export default useUserAttributes;
